import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import HoverButton from "../../components/HoverButton";
import scroll1 from "../../../src/assets/AmberSuiteImg/AS14.jpg";
import circle1 from "../../../src/assets/AmberCircle.png";
import EastIconArrow from "../../../src/assets/east.svg";

gsap.registerPlugin(ScrollTrigger);

const HomeAS = () => {
    const navigate = useNavigate();
    const textRef = useRef(null);
    const imageRef = useRef(null);
    const buttonRef = useRef(null);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        if (imageLoaded) {
            gsap.fromTo(
                textRef.current,
                { x: "-100%", opacity: 0 },
                {
                    x: "0%",
                    opacity: 1,
                    duration: 1.2,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: textRef.current,
                        start: "top 80%",
                        toggleActions: "play reverse play reverse",
                    },
                }
            );

            gsap.fromTo(
                imageRef.current,
                { opacity: 0, scale: 0.8 },
                {
                    opacity: 1,
                    scale: 1,
                    duration: 1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: "top 60%",
                        toggleActions: "play reverse play reverse",
                    },
                }
            );

            gsap.fromTo(
                buttonRef.current,
                { x: "100%", opacity: 0 },
                {
                    x: "0%",
                    opacity: 1,
                    duration: 1.2,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: buttonRef.current,
                        start: "top 80%",
                        toggleActions: "play reverse play reverse",
                    },
                }
            );
        }
    }, [imageLoaded]);

    return (
        <Box sx={{ backgroundColor: "#FDEEB7", width: "100vw", height: "100vh", position: "relative", overflow: "hidden" }}>
            <div ref={textRef} style={{ position: "absolute", top: "15%", left: "5%", color: "#2A2A2A", zIndex: 2, width: "300px" }}>
                <Typography sx={{ fontSize: "50px", fontWeight: "bold" }}>THE AMBER SUITE</Typography>
                <Typography>A warm, elegant space designed with golden hues and wooden accents.</Typography>
            </div>

            <div ref={imageRef} style={{ position: "relative", maxWidth: "438px", height: "585px" }}>
                <img src={scroll1} alt="Amber Suite" style={{ width: "100%", height: "100%", objectFit: "cover" }} onLoad={() => setImageLoaded(true)} />
                <img src={circle1} alt="Circle Decoration" style={{ position: "absolute", width: "175px", height: "175px", bottom: "-50px", left: "0%" }} />
            </div>

            <div ref={buttonRef} style={{ position: "absolute", bottom: "15%", right: "8%", zIndex: 2 }}>
                <HoverButton
                    onClick={() => navigate("/the-amber-suite")}
                    width="132px"
                    height="50px"
                    endIcon={<img src={EastIconArrow} alt="Arrow" style={{ width: "25px", height: "25px" }} />}
                    btnText="Step in"
                    fillBgColor="#F3D991"
                />
                <Typography sx={{ marginTop: "20px" }}>Step into a cozy yet sophisticated retreat. 2000 sq. ft. • max. 4 guests</Typography>
            </div>
        </Box>
    );
};

export default HomeAS;
